import { Component } from "react";

export class Carousel extends Component{
    render(){
        return(
            <div id="home" className="carousel slide" data-bs-ride="carousel">
            <div className="carousel-indicators">
            <button type="button" data-bs-target="#home" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
            <button type="button" data-bs-target="#home" data-bs-slide-to="1" aria-label="Slide 2"></button>
            <button type="button" data-bs-target="#home" data-bs-slide-to="2" aria-label="Slide 3"></button>
            </div>
            <div className="carousel-inner">
            <div className="carousel-item active">
                <img src="https://mdbootstrap.com/img/Photos/Slides/img%20(130).jpg" className="d-block w-100" alt="..."/>
                <div className="carousel-caption d-md-block">
                    <h2>Welcome to Django Blogs</h2>
                </div>
            </div>
            <div className="carousel-item">
                <img src="https://mdbootstrap.com/img/Photos/Slides/img%20(9).jpg" className="d-block w-100" alt="..."/>
                <div className="carousel-caption d-md-block">
                    <h2>Create Blogs</h2>
                </div>
            </div>
            <div className="carousel-item">
                <img src="https://mdbootstrap.com/img/Photos/Slides/img%20(8).jpg" className="d-block w-100" alt="..."/>
                <div className="carousel-caption d-md-block">
                    <h2>And share with the world</h2>
                </div>
            </div>
            </div>
            <button className="carousel-control-prev" type="button" data-bs-target="#home" data-bs-slide="prev">
            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Previous</span>
            </button>
            <button className="carousel-control-next" type="button" data-bs-target="#home" data-bs-slide="next">
            <span className="carousel-control-next-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Next</span>
            </button>
        </div>
        );
    }
}